
import axios from './axios';

const generateDeviceIdentifier = () => Math.random().toString(36).substring(2, 15);

const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (ua.match(/Android/i))           return 'Android';
    if (ua.match(/iPhone|iPad|iPod/i))  return 'iOS';
    if (ua.match(/Windows/i))           return 'Windows';
    if (ua.match(/Macintosh|Mac OS/i))  return 'Mac';
    if (ua.match(/Linux/i))             return 'Linux';
    return 'Unknown';
};

export const login = async (
    username,
    password,
    isAdmin = false,
    loginType = "vision"
) => {
    try {
        const deviceIdentifier = generateDeviceIdentifier();
        const res = await axios.post("login", {
            username,
            password,
            device_identifier: deviceIdentifier,
            device_type: getDeviceType(),
        });

        if (res?.data?.user) {
            localStorage.setItem("admin", isAdmin);
            localStorage.setItem("lastLoginType", loginType); // <-- NEW
            localStorage.setItem("cafeId", res.data.user.cafeId);
            localStorage.setItem("organizationId", res.data.user.organizationId);
            localStorage.setItem("organizationName", res.data.user.organizationName);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("deviceIdentifier", deviceIdentifier)
            localStorage.setItem("token", res.data.token);
            return {
                data: {
                    admin: isAdmin,
                    user: res.data.user.username,
                    dashboardSet: res.data.user.dashboardSet,
                    organizationId: res.data.user.organizationId,
                },
                error: null,
            };
        }

        return {
            data: null,
            error: "User Not Authorized",
        };
    } catch (error) {
        return {
            data: null,
            error,
        };
    }
};

export const logout = async () => {
  try {
    const deviceIdentifier = localStorage.getItem("deviceIdentifier");

    const token = localStorage.getItem("token");

    if (token && deviceIdentifier) {
      await axios.post(
        "logout",
        {
          device_identifier: deviceIdentifier,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  } catch (error) {
    console.error(
      "Logout API error:",
      error?.response?.data || error.message
    );

    throw error;
  } finally {
    localStorage.clear();
    sessionStorage.clear();
  }
};
  